




















import { isSupportWebp } from '@/utils/helper'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Loading extends Vue {
  @Prop() progress
  supportWebp = isSupportWebp()
}
